<template>
  <div v-if="isContentFetched" class="loyalty-reward large-offset-2 columns">
    <div v-if="showLoyaltyReward" data-test-loyalty-reward>
      <div class="loyalty-reward__overview">
        <h2 data-test-loyalty-reward-title v-html="viewModel.loyaltyTitle" />
        <p data-test-loyalty-reward-subtitle v-html="viewModel.loyaltySubtitle" />
        <div class="loyalty-reward__line-break" />
        <h2 class="loyalty-reward__amount" data-test-loyalty-reward-amount v-html="rewardTotal" />

        <p
          data-test-loyalty-reward-info
          class="loyalty-reward__info-text"
          v-html="viewModel.loyaltyInfoText"
        />

        <button
          v-if="viewModel.loyaltyButton"
          data-test-loyalty-reward-button
          class="button tertiary"
          @click="onButtonClick"
          v-html="viewModel.loyaltyButton.text"
        />
      </div>
    </div>
    <div v-if="showRewards">
      <div class="loyalty-reward__overview">
        <h2
          class="small-12 bottom-margin-small"
          data-test-loyalty-reward-motorist-title
          v-html="viewModel.title"
        />
        <div
          v-for="(reward, index) in viewModel.rewards"
          :key="index"
          data-test-loyalty-reward-motorist-plus
          class="row"
        >
          <div class="small-8 columns" data-test-motorist-plus-description>
            <LabelAndTooltip :label="reward.label" :tooltip="reward.tooltip" />
          </div>
          <div
            class="small-4 columns text-right"
            data-test-motorist-plus-price
            v-html="reward.value"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import RequestService from '@/common/requestService';
import Utility from '@/common/UtilityFunctions.js';
import { LoyaltyRewardViewModel, LoyaltyRewardData } from './types/LoyaltyReward';

export default defineComponent({
  name: 'LoyaltyReward',
  props: {
    datasource: {
      type: String,
      default() {
        return '';
      }
    }
  },
  data(): LoyaltyRewardData {
    return {
      viewModel: {
        title: '',
        text: '',
        button: {
          url: '',
          text: ''
        },
        rewards: [],
        rewardTotal: 0,
        category: '',
        seniorityYear: 0,
        discountLevel: 0,
        loyaltyTitle: '',
        loyaltySubtitle: '',
        loyaltyInfoText: '',
        loyaltyButton: {
          url: '',
          text: ''
        },
        disableLoyaltyReward: false
      },
      isContentFetched: false
    };
  },
  computed: {
    rewardTotal(): string {
      return `${this.viewModel.rewardTotal.toString()} kr.`;
    },
    showLoyaltyReward(): boolean {
      return this.viewModel.category === 'A' && !this.viewModel.disableLoyaltyReward;
    },
    showRewards(): boolean {
      return this.viewModel.rewards != null && this.viewModel.rewards.length > 0;
    }
  },
  mounted() {
    this.getViewModel();
  },
  methods: {
    async getViewModel(): Promise<void> {
      await RequestService.get<LoyaltyRewardViewModel>(
        `${Utility.constants().API.loyality_reward_get}/${this.datasource}`
      )
        .then((response) => {
          const data = response.data;
          this.viewModel = data;
          this.isContentFetched = true;
        })
        .catch((err) => Utility.logError(err, this));
    },
    onButtonClick() {
      location.href = this.viewModel.loyaltyButton.url;
    }
  }
});
</script>
<style lang="scss" scoped>
@import 'src/styles/all.scss';

.loyalty-reward {
  &__overview {
    padding: rem-calc(32);
    margin-bottom: rem-calc(16);
    background: $body-background;
  }

  &__line-break {
    width: 100%;
    height: 2px;
    background-color: $medium-gray;
    margin: auto;
  }

  &__info-text {
    color: $dark-gray;
    padding-bottom: rem-calc(16);
  }

  &__amount {
    color: $black;
    padding: rem-calc(8) 0;
  }
}
</style>
